module.exports = __webpack_public_path__ + "static/media/headstorm_logo.872b2a80.png";